/**
 * @generated SignedSource<<063d9b89a07b29be48fc8b9ab0b18e37>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SpeakInput = {
  errorRecordId?: string | null | undefined;
  examplePracticeItemId?: string | null | undefined;
  practiceItemId?: string | null | undefined;
  sentence?: number | null | undefined;
  slow?: boolean | null | undefined;
  storyPageId?: string | null | undefined;
  turnAidId?: string | null | undefined;
  turnId?: string | null | undefined;
  vocabularyItemId?: string | null | undefined;
};
export type AidsPanelSpeakMutation$variables = {
  input: SpeakInput;
};
export type AidsPanelSpeakMutation$data = {
  readonly speak: {
    readonly wavBase64: string;
  };
};
export type AidsPanelSpeakMutation = {
  response: AidsPanelSpeakMutation$data;
  variables: AidsPanelSpeakMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SpeakPayload",
    "kind": "LinkedField",
    "name": "speak",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wavBase64",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AidsPanelSpeakMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "AidsPanelSpeakMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "dbf52565449e58c3bf0074eafaaa7e97",
    "id": null,
    "metadata": {},
    "name": "AidsPanelSpeakMutation",
    "operationKind": "mutation",
    "text": "mutation AidsPanelSpeakMutation(\n  $input: SpeakInput!\n) {\n  speak(input: $input) {\n    wavBase64\n  }\n}\n"
  }
};
})();

(node as any).hash = "31002ee1106833567d239db0e7af9530";

export default node;
